import { useProfileQuery } from '../hooks/Profile';

interface LoadUserProps {
  children: JSX.Element;
}

const LoadProfile = ({ children }: LoadUserProps) => {
  const profileQuery = useProfileQuery();
  if (!profileQuery.data?.user) {
    return null;
  }
  return children;
};

export default LoadProfile;
